import Success from "@pathwright/ui/src/components/success/Success"
import PathwrightUI from "@pathwright/ui/src/components/ui/PathwrightUI"
import { usePathwrightContext } from "@pathwright/web/src/modules/pathwright/PathwrightContext"
import { ConnectStores } from "lib/core/store"
import get from "lodash/get"

const MessageSuccess = ({ onClose, resource }) => {
  const { me } = usePathwrightContext()

  return (
    <PathwrightUI.Provider
      theme={{
        backgroundImage: get(resource, "background_image_blurred_cdn"),
        backgroundOverlay: get(resource, "background_overlay")
      }}
    >
      <Success
        icon="check"
        heading="Message sent!"
        body={`Learners can send a reply to ${me.email}.`}
        primaryAction={{
          children: "Done",
          onClick: onClose,
          size: "large"
        }}
        onBackgroundClick={onClose}
      />
    </PathwrightUI.Provider>
  )
}

MessageSuccess.displayName = "MessageSuccess"

const mapStateToProps = (state, ownProps) => {
  const { resource } = state.resourceStore.state

  return {
    ...ownProps,
    resource
  }
}

const stores = [{ store: "resource", watch: false }]

export default ConnectStores(MessageSuccess, stores, {}, mapStateToProps)
